import { render, staticRenderFns } from "./OverdueTasksNotification.vue?vue&type=template&id=1e3dc7da&"
import script from "./OverdueTasksNotification.vue?vue&type=script&lang=js&"
export * from "./OverdueTasksNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports